import React from 'react';
import { use100vh } from 'react-div-100vh';
import ModalContainer from 'components/Modal/ModalContainer/ModalContainer';
import { useStyles } from './VideoModal.styles';
import YouTube, { Options } from 'react-youtube';
import { onPlayerStateChange } from 'helpers/YoutubeDataTracking';

interface VideoProps {
  closeFunction: () => void;
  isOpen: boolean;
  videoId: string;
  autoplay?: boolean;
  fullscreen?: boolean;
}

const VideoModal = ({
  closeFunction,
  isOpen,
  videoId,
  autoplay,
  fullscreen,
}: VideoProps): JSX.Element => {
  const viewHeightValue = use100vh();
  const viewHeightStyle = viewHeightValue
    ? `${viewHeightValue / 16}rem`
    : '100%';
  const classes = useStyles({ viewHeight: viewHeightStyle });
  const opts: Options = {
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: autoplay ? 1 : 0,
      fs: fullscreen ? 1 : 0,
    },
  };

  return (
    <ModalContainer
      isNotReact
      closeFunction={closeFunction}
      isOpen={isOpen}
      title={'Youtube video player'}
      className={classes.paper}
      isVideo
    >
      <div className={classes.modal_area}>
        <YouTube
          className={classes.video_frame}
          videoId={videoId}
          opts={opts}
          title="YouTube video player"
          containerClassName={classes.content}
          onStateChange={onPlayerStateChange}
        />
      </div>
    </ModalContainer>
  );
};

export default VideoModal;
